import { RootState } from '../reducers'

export const splashScreenUrlSelector = (state: RootState) => state.splashScreen.url

export const splashScreenPendingUrlSelector = (state: RootState) => state.splashScreen.pendingUrl
